import useLabel from "@apps/use-label/use-label";
import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

import useRolesAskAiSidebar from "./use-roles-ask-ai-sidebar";

// Shared "Build with AI" button (page headers and the empty-state banner):
// opens the Ask AI sidebar and starts the role framework chat there. Without
// Ask AI there's no sidebar to open, so there's no button either.
export const BuildWithAiButton = () => {
  const { isAvailable, expanded, toggleBuildWithAi } = useRolesAskAiSidebar();
  if (!isAvailable) return null;
  return (
    <Button
      size={ButtonSize.medium}
      // Filled while the sidebar is open, like the layout's sidebar toggle.
      theme={expanded ? buttonTheme.lightGray : buttonTheme.default}
      aria-pressed={expanded}
      onClick={toggleBuildWithAi}
    >
      Build with AI
      <TopicflowIcon type="toggleSidebar" className="h-4 w-4" />
    </Button>
  );
};

// Starts the import skill in the sidebar, for a framework kept somewhere else
// that the admin pastes into the chat.
const ImportWithAiButton = () => {
  const { startImport } = useRolesAskAiSidebar();
  return (
    <Button size={ButtonSize.medium} onClick={startImport}>
      Import existing
    </Button>
  );
};

// Shown while the organization has no career tracks or competencies yet. On
// large screens the buttons sit top right; below that they wrap under the text.
export const RoleFrameworkBanner = () => {
  const label = useLabel();
  const { isAvailable } = useRolesAskAiSidebar();
  if (!isAvailable) return null;
  return (
    <section
      aria-label="Build role framework"
      className="rounded-lg border border-blue-200 bg-blue-50 p-6 mb-12 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between"
    >
      <div>
        <h2 className="font-semibold mb-1">
          Build your role and {label("competency")} framework
        </h2>
        <p className="text-sm text-gray-600">
          Answer a few questions about your people and their work, or paste in a
          framework you already have. Topicflow AI will help you define roles,
          expectations, and employee assignments.
        </p>
      </div>
      <div className="shrink-0 flex items-center gap-2">
        <ImportWithAiButton />
        <BuildWithAiButton />
      </div>
    </section>
  );
};
